import axios from "axios";
import { useEffect, useState } from "react";

const Location = () => {


   const [NearPoint, setNearPoint] = useState([]);

    useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_all_points"
      );
      setNearPoint(response.data.data);
    };

    fetchData();
  }, []);


    const [Location, setLocation] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/get_location_list"
      );
      setLocation(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <div className="location-div">
      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 location-section spad">
              <div className="location-text">
                {Location.map((user) => (
                <div className="location-title">
                  <h2>{user.location_address}</h2>
                </div>
                ))}
              </div>
            </div>
            <div className="map col-lg-6 left-location">
              <div className="map-location">
                <a
                  href="https://maps.app.goo.gl/baHGyy7GDApEVr9C7?g_st=aw"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="animated-link"
                >
                  👉 View 360° Images
                </a>
              </div>

              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.542317941358!2d79.07219167430787!3d21.090934485642027!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4bf0e09451fc9%3A0x22c3bd8a0d325e4c!2s26%2C%20Jai%20Hind%20Society%2C%20Shyam%20Nagar%2C%20Manish%20Nagar%2C%20Somalwada%2C%20Nagpur%2C%20Maharashtra%20440015!5e0!3m2!1sen!2sin!4v1745498522464!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
                title="map"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="location-detail spad1">
        <div className="container">
          <div className="row">
            <h1 className="text-center" style={{fontSize:"40px"}}>Nearest Points</h1>
            <div className="row">
              {NearPoint.map((point, index) => (
              <div className="col-md-3 dining-section" key={index}>
                <img src={`https://cyberathon.com/silverapartment/${point.loc_image}`} loading="lazy" alt="Near Pint Image" className="transmit-img1" />
                <h2>{point.loc_heading}</h2>
                <p>{point.loc_description}</p>
              </div>
              ))}
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Location;
